import React from 'react';
import { motion } from 'framer-motion';
export function ProtocolSection() {
  const phases = [{
    id: 'H',
    days: 'DÍAS 1-7',
    name: 'FASE H (HORMONAL)',
    gradient: 'from-primary to-gold',
    icon: '🧬',
    description: 'Alimentos específicos para apoyar energía, apetito y metabolismo.'
  }, {
    id: 'E',
    days: 'DÍAS 8-14',
    name: 'FASE E (ENZIMÁTICA)',
    gradient: 'from-rosa to-primary',
    icon: '🔥',
    description: 'Estrategias para mejorar digestión, inflamación y uso de energía.'
  }, {
    id: 'R',
    days: 'DÍAS 15-21',
    name: 'FASE R (RESTAURATIVA)',
    gradient: 'from-gold to-secondary',
    icon: '✨',
    description: 'Repara tu metabolismo y consolidá una rutina sostenible con secuencias específicas.'
  }];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-228">
      <div className="max-w-[1400px] mx-auto space-y-16" data-id="element-229">
        {/* Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center space-y-6" data-id="element-230">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-black" data-id="element-231">
            El <span className="text-gradient-gold" data-id="element-232">Protocolo H.E.R.</span>
          </h2>

          <p className="text-xl md:text-2xl text-foreground/90 font-body leading-relaxed" data-id="element-233">
            Después de los 35, el cuerpo cambia. En 21 días podés volver a
            sentirte más estable con un sistema por fases{' '}
            <span className="text-secondary font-bold" data-id="element-234">(H/E/R)</span>.
          </p>
        </motion.div>

        {/* 3 Phases Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-235">
          {phases.map((phase, i) => <motion.div key={phase.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-card border border-border rounded-2xl p-6 md:p-8 relative overflow-hidden hover:border-gold/40 transition-colors duration-300 group" data-id="element-236">
              <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${phase.gradient}`} data-id="element-237" />

              <div className="space-y-4" data-id="element-238">
                <div className="flex items-center justify-between" data-id="element-239">
                  <span className="text-4xl" data-id="element-240">{phase.icon}</span>
                  <span className="text-sm font-bold tracking-widest text-foreground/60 uppercase" data-id="element-241">
                    {phase.days}
                  </span>
                </div>

                <h3 className="text-xl font-display font-bold text-foreground group-hover:text-gold transition-colors" data-id="element-242">
                  {phase.name}
                </h3>

                <p className="text-foreground/80 font-body text-base font-medium leading-relaxed" data-id="element-243">
                  {phase.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}